// Column ids, tab ids and the detail route's composite key.

export const INVENTORY_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  materialName: 'materialName',
  materialId: 'materialId',
  materialRole: 'materialRole',
  facilityName: 'facilityName',
  terminal: 'terminal',
  unitType: 'unitType',
  availableQuantity: 'availableQuantity',
});

// `inventory` takes no orderBy, so no column is sortable.
// TODO: mark columns sortable once `InventoryOrderBy` exists.
export const INVENTORY_SORT_FIELDS = Object.freeze({});

export const INVENTORY_DETAIL_TABS = Object.freeze({
  summary: 'summary',
  inbounds: 'inbounds',
  outbounds: 'outbounds',
  transactions: 'transactions',
});

export const INVENTORY_SUMMARY_TABS = Object.freeze({
  movement: 'movement',
  reconciliation: 'reconciliation',
  massBalance: 'massBalance',
});

export const INVENTORY_INBOUND_TABS = Object.freeze({
  contracts: 'contracts',
  incomingShipments: 'incomingShipments',
  declarations: 'declarations',
});

export const INVENTORY_OUTBOUND_TABS = Object.freeze({
  orders: 'orders',
  outgoingShipments: 'outgoingShipments',
  allocations: 'allocations',
});

// Material movement has two shapes of the same period: aggregated rows, or every movement.
export const MOVEMENT_VIEWS = Object.freeze({ detailed: 'detailed', summary: 'summary' });
